import { RootState } from "../types";


export const adminListSelector = (state: RootState) => state.admin.langTranslate;
export const isSuperAdmin = (state: RootState) => state.admin.isSuperAdmin;
